// @ts-strict-ignore
import { useQuery } from '@tanstack/react-query';
import { ajaxFetch } from '~/helpers/api';
import { useFetchedUserContext } from '~/helpers/hooks';
import { routes } from '~/helpers/routes';

export const useEvaluationFraudScores = ({ evaluationToken }) => {
  const { feature_flags: featureFlags } = useFetchedUserContext();
  const useEvaluationFraudScoresDBSourceOfTruth = featureFlags
    ?.['use-evaluation-fraud-scores-db-source-of-truth'] ?? false;

  return useQuery({
    queryKey: ['fraud-scores', evaluationToken],
    queryFn: async () => ajaxFetch(
      routes.evaluations.fraudScores(evaluationToken),
    ).then(({ scores }) => scores),
    enabled: useEvaluationFraudScoresDBSourceOfTruth,
  });
};
